(function () {
  const CENTERED_CAROUSEL = '.template-index [id*="__categories"] carousel-slider, .isun-partners-gallery carousel-slider';
  const ROUTINE_MOBILE_CAROUSEL = '.template-product .isun-routine-products';
  const settleTimers = new WeakMap();
  const programmaticTimers = new WeakMap();

  function getCarouselParts(carousel) {
    return {
      slider: carousel.querySelector('.slider'),
      slides: Array.from(carousel.querySelectorAll('.slider__item:not([hidden])'))
    };
  }

  function getClosestCenteredSlide(carousel) {
    const parts = getCarouselParts(carousel);
    if (!parts.slider || parts.slides.length === 0) return null;

    const sliderRect = parts.slider.getBoundingClientRect();
    const sliderCenter = sliderRect.left + (sliderRect.width / 2);
    let closestSlide = parts.slides[0];
    let closestDistance = Infinity;

    parts.slides.forEach(function (slide) {
      const slideRect = slide.getBoundingClientRect();
      const slideCenter = slideRect.left + (slideRect.width / 2);
      const distance = Math.abs(slideCenter - sliderCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestSlide = slide;
      }
    });

    return closestSlide;
  }

  function setActiveSlide(carousel) {
    const parts = getCarouselParts(carousel);
    const activeSlide = getClosestCenteredSlide(carousel);
    if (!activeSlide) return;

    parts.slides.forEach(function (slide) {
      const isActive = slide === activeSlide;
      slide.classList.toggle('is-active', isActive);
      if (isActive) {
        slide.setAttribute('aria-current', 'true');
      } else {
        slide.removeAttribute('aria-current');
      }
    });

    updateCenteredCarouselButtons(carousel, parts.slides.indexOf(activeSlide));
  }

  function updateCenteredCarouselButtons(carousel, activeIndex) {
    const parts = getCarouselParts(carousel);
    if (!parts.slider || parts.slides.length === 0) return;

    const isScrollable = parts.slider.scrollWidth > parts.slider.clientWidth + 2;
    carousel.toggleAttribute('inactive', !isScrollable);

    const currentIndex = activeIndex == null ? parts.slides.indexOf(getClosestCenteredSlide(carousel)) : activeIndex;
    const prev = carousel.querySelector('.slider-nav__btn[name="prev"]');
    const next = carousel.querySelector('.slider-nav__btn[name="next"]');
    if (!prev || !next) return;

    prev.disabled = !isScrollable || currentIndex <= 0;
    next.disabled = !isScrollable || currentIndex >= parts.slides.length - 1;
  }

  function scrollSlideToCenter(carousel, slide, behavior) {
    const parts = getCarouselParts(carousel);
    if (!parts.slider || !slide) return;

    const targetLeft = slide.offsetLeft - ((parts.slider.clientWidth - slide.clientWidth) / 2);
    const maxLeft = parts.slider.scrollWidth - parts.slider.clientWidth;
    const left = Math.max(0, Math.min(targetLeft, maxLeft));

    parts.slider.scrollTo({
      left: left,
      behavior: behavior || 'smooth'
    });

    window.setTimeout(function () {
      setActiveSlide(carousel);
      updateCenteredCarouselButtons(carousel);
    }, 260);
  }

  function snapToNearestSlide(carousel) {
    const parts = getCarouselParts(carousel);
    if (!parts.slider || parts.slider.classList.contains('is-grabbing')) return;

    const activeSlide = getClosestCenteredSlide(carousel);
    programmaticTimers.set(carousel, Date.now() + 320);
    scrollSlideToCenter(carousel, activeSlide, 'smooth');
  }

  function scheduleSnap(carousel) {
    window.clearTimeout(settleTimers.get(carousel));
    setActiveSlide(carousel);
    if (Date.now() < (programmaticTimers.get(carousel) || 0)) return;

    settleTimers.set(carousel, window.setTimeout(function () {
      snapToNearestSlide(carousel);
    }, 140));
  }

  function stepCarousel(carousel, direction) {
    const parts = getCarouselParts(carousel);
    if (!parts.slider || parts.slides.length === 0) return;

    const activeSlide = getClosestCenteredSlide(carousel) || parts.slides[0];
    const currentIndex = Math.max(0, parts.slides.indexOf(activeSlide));
    const nextIndex = Math.max(0, Math.min(currentIndex + direction, parts.slides.length - 1));

    window.clearTimeout(settleTimers.get(carousel));
    programmaticTimers.set(carousel, Date.now() + 420);
    scrollSlideToCenter(carousel, parts.slides[nextIndex], 'smooth');
  }

  function initCategoryCarousel(carousel) {
    if (!carousel || carousel.dataset.isunCenteredCarousel === 'true') return;
    const parts = getCarouselParts(carousel);
    if (!parts.slider || parts.slides.length < 2) return;

    carousel.dataset.isunCenteredCarousel = 'true';
    setActiveSlide(carousel);
    updateCenteredCarouselButtons(carousel);

    parts.slider.addEventListener('scroll', function () {
      scheduleSnap(carousel);
    }, { passive: true });

    carousel.addEventListener('click', function (event) {
      const button = event.target.closest('.slider-nav__btn');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const isNext = button.getAttribute('name') === 'next';
      stepCarousel(carousel, isNext ? 1 : -1);
    }, true);
  }

  function initCategoryCarousels() {
    document.querySelectorAll(CENTERED_CAROUSEL).forEach(initCategoryCarousel);
  }

  function getRoutineParts(section) {
    const slider = section.querySelector('.collection-listing');
    return {
      slider: slider,
      slides: slider ? Array.from(slider.querySelectorAll('.product-grid > .product-block')) : [],
      prev: section.querySelector('.isun-routine-mobile-nav__btn[name="prev"]'),
      next: section.querySelector('.isun-routine-mobile-nav__btn[name="next"]')
    };
  }

  function getClosestRoutineIndex(section) {
    const parts = getRoutineParts(section);
    if (!parts.slider || parts.slides.length === 0) return 0;

    let closestIndex = 0;
    let closestDistance = Infinity;
    parts.slides.forEach(function (slide, index) {
      const distance = Math.abs(slide.offsetLeft - parts.slider.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function updateRoutineButtons(section) {
    const parts = getRoutineParts(section);
    if (!parts.prev || !parts.next || parts.slides.length === 0) return;

    const currentIndex = getClosestRoutineIndex(section);
    parts.prev.disabled = currentIndex <= 0;
    parts.next.disabled = currentIndex >= parts.slides.length - 1;
  }

  function scrollRoutine(section, direction) {
    const parts = getRoutineParts(section);
    if (!parts.slider || parts.slides.length === 0) return;

    const currentIndex = getClosestRoutineIndex(section);
    const nextIndex = Math.max(0, Math.min(currentIndex + direction, parts.slides.length - 1));
    parts.slider.scrollTo({
      left: parts.slides[nextIndex].offsetLeft,
      behavior: 'smooth'
    });

    window.setTimeout(function () {
      updateRoutineButtons(section);
    }, 260);
  }

  function initRoutineMobileCarousel(section) {
    if (!section || section.dataset.isunRoutineCarousel === 'true') return;
    const parts = getRoutineParts(section);
    if (!parts.slider || parts.slides.length < 2) return;

    section.dataset.isunRoutineCarousel = 'true';
    updateRoutineButtons(section);

    parts.slider.addEventListener('scroll', function () {
      window.clearTimeout(settleTimers.get(section));
      settleTimers.set(section, window.setTimeout(function () {
        updateRoutineButtons(section);
      }, 80));
    }, { passive: true });

    section.addEventListener('click', function (event) {
      const button = event.target.closest('.isun-routine-mobile-nav__btn');
      if (!button) return;

      event.preventDefault();
      scrollRoutine(section, button.getAttribute('name') === 'next' ? 1 : -1);
    });
  }

  function initRoutineMobileCarousels() {
    document.querySelectorAll(ROUTINE_MOBILE_CAROUSEL).forEach(initRoutineMobileCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCategoryCarousels();
      initRoutineMobileCarousels();
    });
  } else {
    initCategoryCarousels();
    initRoutineMobileCarousels();
  }

  document.addEventListener('shopify:section:load', function () {
    initCategoryCarousels();
    initRoutineMobileCarousels();
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll(CENTERED_CAROUSEL).forEach(setActiveSlide);
    document.querySelectorAll(ROUTINE_MOBILE_CAROUSEL).forEach(updateRoutineButtons);
  });
})();

(function () {
  let bars = [];
  let frame = 0;
  let clearance = -1;
  const resizeObserver = new ResizeObserver(schedule);
  const stateObserver = new MutationObserver(schedule);

  function update() {
    frame = 0;
    let next = 0;
    bars.forEach(function (bar) {
      if (!bar.isConnected || bar.classList.contains('sticky-atc--out')) return;
      if (bar.matches('.sticky-atc') && document.body.classList.contains('scrolled-to-bottom')) return;
      if (bar.matches('[data-lp-sticky]') && !bar.classList.contains('is-visible')) return;
      if (bar.getBoundingClientRect().left >= 44) return;
      const style = getComputedStyle(bar);
      if (style.display === 'none') return;
      if (!bar.matches('[data-lp-sticky]') && style.visibility === 'hidden') return;
      next = Math.max(next, Math.ceil(bar.offsetHeight + (parseFloat(style.bottom) || 0)));
    });
    if (next !== clearance) {
      clearance = next;
      document.documentElement.style.setProperty('--isun-sticky-clearance', next + 'px');
    }
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function observe() {
    bars.forEach(function (bar) { bar.removeEventListener('transitionend', schedule); });
    resizeObserver.disconnect();
    stateObserver.disconnect();
    bars = Array.from(document.querySelectorAll('.sticky-atc, [data-lp-sticky]'));
    if (!bars.length) return;
    stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    bars.forEach(function (bar) {
      resizeObserver.observe(bar);
      bar.addEventListener('transitionend', schedule);
      stateObserver.observe(bar, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    });
    schedule();
  }

  observe();
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', observe);
})();
